import { PERCENT_SYMBOL } from 'modules/core/constants';
import React from 'react';

export const PercentAdornment: React.FC = () => <span>{PERCENT_SYMBOL}</span>;
